import { Component, OnInit, Input, AfterContentInit, NgZone, ChangeDetectorRef, AfterViewInit, AfterContentChecked, Output, EventEmitter, ViewChild, HostListener, TemplateRef, ViewContainerRef, EmbeddedViewRef, inject } from '@angular/core';
import { SemControlComponent } from '../sem-control/sem-control.component';
import { ValueAccessorBase } from '../shared/value-accessor/value-accessor-base';
import { RestProviderService } from '../../../services/rest-provider/rest-provider.service';
import { NG_VALUE_ACCESSOR, FormControl } from '@angular/forms';
import { RequestModel } from 'src/app/models/request/request-model';
import * as _ from "lodash";
import { Observable, of, Subject, Subscription } from 'rxjs';
import { startWith, map, takeUntil } from 'rxjs/operators';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatSelect } from '@angular/material/select';
import { MatOption, MatOptionSelectionChange } from '@angular/material/core';
import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { SemQuickCreateFormDialogComponent, QuickCreateFormDialogResult } from '../dialogs/sem-quick-create-form-dialog/sem-quick-create-form-dialog.component';


@Component({
    selector: 'sem-drop-down-select',
    templateUrl: './sem-select.component.html',
    styleUrls: ['./sem-select.component.css'],
    host: {
        '[class.radio-select-layout]': 'type == 3'
    },
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: SemSelectComponent, multi: true }
    ],
    standalone: false
})
export class SemSelectComponent extends ValueAccessorBase<any> implements OnInit, AfterViewInit {

  ngAfterViewInit() {

  }

  @Input() list: any[] = [];
  @Input() galregistryname: string;
  @Input() subBindingPropertyName: string;
  @Input() titleField: string;
  @Input() searchQueryFilter: any = {};
  @Input() type: any = 1;
  @Input() filterField: any = "Title";
  @Input() preLoad: any;
  @Input() useAsMultiField: boolean = false;
  @Input() autoSelectFirstEntry: boolean = false;
  @Input() clientUIControl: boolean = false;
  @Input() multiFieldRootPropertyBinding: string = "";
  @Input() multiFieldPropertyName: string = "";
  @Input() waitForFilteredValue: boolean = false;
  @Input() useNhibernate: boolean = false;
  @Input() filteredValueBinding: string = "";
  @Input() additionalProjection: any[] = [];
  @Input() customPageSize: any;
  @Input() defaultValue: any;
  @Input() onSelectPostJS: string = null;
  @Input() onClearPostJS: string = null;
  @Input() customDataApi: string = null;
  @Input() minWidth: string = "auto";
  @Input() autoSelectCondition: string = "";
  @Input() autoSelectConditionValue: string = "";
  @Input() isReadOnly: any;
  @Input() useGlobalModel: boolean = false;
  @Input() customDataApiInputParameters: any = null;
  @Input() autoSelectFirstEntryCondition: any = null;
  @Input() loadItemsOnModelLoad: any = null;
  @Input() placeholder: string = "";
  @Input() pageSize: any = 40;
  @Input() readOnlyCondition: any;
  @Input() useCustomApiCondition: string = "";
  @Input() sortFields: any[] = [];

  // Quick-create — lets the user add a missing entry without leaving the form.
  //   inline    : small input + Save as the last row of the dropdown panel (single-field create).
  //   full-form : "Dodaj nov vnos" as the last row of the dropdown panel; opens the backend form
  //               (QuickCreateFormId, or the registry's own form) in a MatDialog with Shrani/Preklici.
  //   panel     : key button beside the select; registry form in the bottom split drawer (iframe).
  @Input() enableQuickCreate: boolean = false;
  @Input() quickCreateMode: 'inline' | 'panel' | 'full-form' = 'inline';
  @Input() quickCreateRegistry: string = '';
  // dbo.DynamicForm Id for full-form mode; 0 = resolve the form from the registry name.
  @Input() quickCreateFormId: number | string = 0;

  // Inline-create state
  inlineCreateText: string = '';
  inlineCreating: boolean = false;
  inlineCreatePlaceholder: string = 'Ime novega zapisa';

  @ViewChild('inlineCreateFooterTpl', { static: false }) inlineCreateFooterTpl: TemplateRef<any> | undefined;
  @ViewChild('fullFormFooterTpl', { static: false }) fullFormFooterTpl: TemplateRef<any> | undefined;
  private inlineFooterRef: EmbeddedViewRef<any> | null = null;
  private inlineFooterVcr = inject(ViewContainerRef);

  itemsLoaded = false;
  _isDisabled: boolean;

  // Signature (url + interpolated payload) of the last autocomplete request that actually returned data.
  // Used to skip a repeated identical call - the search term alone is not enough, since the custom API
  // payload is interpolated from the current form model and can change while the term stays the same.
  previousRequestKey: string = null;

  private additionalProjectionOriginal: any[] = [];

  @Output() itemSelected: EventEmitter<MatOption> = new EventEmitter<MatOption>();
  @ViewChild(MatSelect, { read: MatSelect, static: true }) matSelect: MatSelect;
  initialSet: boolean = false;
  selectedValueId: string;

  formModel: any;
  private loadedOnModelLoad = false;
  myControl = new FormControl();

  multiFields: any[] = [];
  filteredOptions: Observable<any[]>;
  loadingResults: boolean = false;
  req: Subject<void> = new Subject<void>();
  // backend denies and return 500 api response if search is FieldName:* + FieldValue:*
  query = JSON.parse("{ \"MainQuery\": null, \"FieldQueries\": { }, \"FacetQueries\": { }, \"RequestedFacets\": null, \"Projection\": [], \"TreeQuery\": { \"Type\": \"FieldRange\", \"FieldName\": \"Id\", \"FieldValueFrom\": 1, \"FieldValueTo\": \"*\" }, \"ClassTypes\": [], \"Page\": \"1\", \"PageSize\": " + this.pageSize + ", \"RepositoryName\": \"lucene\", \"Form\": null, \"UseCache\": false, \"Facets\": [], \"SortFields\": [] }");
  //private subscription: Subscription;
  bindingPropertyName: string = "";
  private filteredValueSubs: any = null;
  private newSectionAddedObsrvProp: Subscription = null;
  id = 0;
  preSelectedEntity = null;
  private dropdownOptionsLoaded: boolean = false;
  autoselect = true;

  conditionApplied: boolean = false;
  conditionValue: any = null;

  valueRemoved: boolean = false;
  // autocomplete (type 2): the user left the input / the options panel is open
  typedInputLeft: boolean = false;
  autocompletePanelOpen: boolean = false;

  // ===== Tree mode (type == 4) =====
  // Hierarchical registries (e.g. Material, Classification) are rendered as an inline
  // collapsible tree built client-side from the flat dropdown list using each item's Parent.Id.
  treeControl = new NestedTreeControl<any>(node => node.children);
  treeDataSource = new MatTreeNestedDataSource<any>();
  treePanelOpen: boolean = false;
  treeFilter: string = "";
  private treeFlatNodes: any[] = [];

  super() { }

  ngOnDestroy(): void {

    this.detachInlineFooter();
    this.utility.newDropdownValueSelected(undefined, undefined);
    if (typeof this.filteredValueSubs != "undefined" && this.filteredValueSubs != null) {
      this.filteredValueSubs.unsubscribe();
    }

    if (this.newSectionAddedObsrvProp) {
      this.newSectionAddedObsrvProp.unsubscribe();
    }
  }

  getReadOnly() {
    if (this.isReadOnly != null && typeof this.isReadOnly != "undefined") {
      return this.isReadOnly;
    }

    if (this.readOnlyCondition != null && typeof this.readOnlyCondition != "undefined" && this.readOnlyCondition.length > 0) {

      let resultOfEval = eval(this.readOnlyCondition);

      if (resultOfEval == true) {
        this.isReadOnly = true;
        return true;
      } else {
        this.isReadOnly = false;
      }
    }

    return false;
  }

  ngOnInit() {

    if (this.useNhibernate) {
      // backend denies and return 500 api response if search is FieldName:* + FieldValue:*
      this.query = JSON.parse("{ \"MainQuery\": null, \"FieldQueries\": { }, \"FacetQueries\": { }, \"RequestedFacets\": null, \"Projection\": [], \"TreeQuery\": { \"Type\": \"FieldRange\", \"FieldName\": \"Id\", \"FieldValueFrom\": 1, \"FieldValueTo\": \"*\" }, \"ClassTypes\": [], \"Page\": \"1\", \"PageSize\": " + this.pageSize + ", \"RepositoryName\": \"nhibernate\", \"Form\": null, \"UseCache\": false, \"Facets\": [], \"SortFields\": [] }");
    }

    if (Object.prototype.toString.call(this.additionalProjection) === '[object Array]') {
      this.additionalProjectionOriginal = Object.assign([], this.additionalProjection);
    } else if (Object.prototype.toString.call(this.additionalProjection) === '[object String]') {
      var res = this.additionalProjection.toString().split(",");
      var array: any[] = [];
      for (var i = 0; i < res.length; i++) {
        array.push(res[i]);
      }
      this.additionalProjectionOriginal = Object.assign([], array);
    }


    if (typeof (this.type) == "undefined" || this.type == 0) {
      this.type = 1;
    }

    // Tree mode needs the full registry (not a 40-item page) so the hierarchy can be reconstructed client-side.
    if (this.type == 4) {
      this.query["PageSize"] = 100000;
    }

    this.route
      .queryParams
      .subscribe(params => {
        // Defaults to 0 if no query param provided.
        this.params = params;
      });

    if (typeof (this.filterField) == "undefined" || this.filterField == null || this.filterField == "") {
      this.filterField = "Title";
    }

    let name = this.getAttribute("name");
    if (name != null && typeof name != "undefined") {
      this.bindingPropertyName = name.replace("model.", "");
    }


    if (this.type == 1 || this.type == 3 || this.type == 4) {
      if (this.waitForFilteredValue == false) {
        // if default value specified load only this value
        // after first click on dropdown loadItems() will execute
        // also load default value on empty details page (if id specified we load actual value from db - based on response)
        // Tree mode always loads the full list (it needs every node to build the hierarchy), so it skips the default-value-only path.
        if (this.type != 4 && this.defaultValue != null && typeof this.defaultValue != "undefined" && this.defaultValue != "" && (this.params["id"] == null || typeof this.params["id"] == "undefined" || this.params["id"] == 0)) {
          this.loadItems(parseInt(this.defaultValue));
        } else {
          this.dropdownOptionsLoaded = true;
          this.loadItems();
        }
      }
    } else {
      // if default value specified on autocomplete load default value            
      // also load default value on empty details page (if id specified we load actual value from db - based on response)                
      if (this.defaultValue != null && typeof this.defaultValue != "undefined" && this.defaultValue != "" && (this.params["id"] == null || typeof this.params["id"] == "undefined" || this.params["id"] == 0)) {
        this.loadItems(parseInt(this.defaultValue));
      }

      if (this.checkForDisabled(this.getAttribute('name')) == true) {
        this.myControl.disable();
      }
    }

    // register listener 
    if (this.waitForFilteredValue != null && typeof this.waitForFilteredValue != "undefined" && this.waitForFilteredValue == true) {
      this.filteredValueSubs = this.utility.currentDropdownSelectedValue.subscribe(value => {

        if (typeof value != "undefined" && value != null
          && typeof value["SelectedDropDownBinding"] != "undefined" && value["SelectedDropDownBinding"] != null
          && typeof value["SelectedValue"] != "undefined" && value["SelectedValue"] != null) {

          // check if correct dropdown
          if (this.filteredValueBinding == value["SelectedDropDownBinding"]) {
            // if standard dropdown, fire search
            // if autocomplete we dont need to fire search because it will be fired when user clicks on dropdown
            if (this.type == 1 || this.type == 3) {
              if (this.defaultValue != null && typeof this.defaultValue != "undefined" && this.defaultValue != "" && (this.params["id"] == null || typeof this.params["id"] == "undefined" || this.params["id"] == 0)) {
                this.loadItems(parseInt(this.defaultValue));
              } else {
                this.loadItems();
              }
              //this.loadItems();
            }
          }
        }
      });
    }

    this.newSectionAddedObsrvProp = this.utility.newSectionAddedObsr.subscribe((val) => {
      if (typeof this.autoSelectCondition != "undefined" && this.autoSelectCondition && this.autoSelectCondition.length > 0) {
        try {
          var evalVal = eval("function doIt(model){" + this.autoSelectCondition + "} doIt(val);");

          if (typeof evalVal != "undefined" && evalVal && evalVal > 0) {
            this.id = evalVal;
            this.value = this.list[this.id];
          } else {
            this.id = 0;
            this.value = null;
          }
          this.changeDetection.detectChanges();
        }
        catch (e) {
          console.log("Error setting default value from autoselect condition", e);
        }
      }
    });

    this.restProviderService.modelValueChanged.subscribe(model => {
      if (typeof model != "undefined" && model && Object.keys(model).length > 0) {
        if (this.preSelectedEntity) {
          let currentVal = this.dfms.getValue(model, this.bindingPropertyName);
          if (typeof currentVal == "undefined" || !currentVal) {
            this.value = this.preSelectedEntity;
            this.changeDetection.detectChanges();
          }
        }

        if (this.type == 3) {

          let selectedVal = this.dfms.getValue(model, this.bindingPropertyName);

          if (typeof selectedVal != "undefined" && selectedVal) {
            for (var i = 0; i < this.list.length; i++) {
              if (this.list[i]["Id"] == selectedVal["Id"]) {
                this.list[i] = selectedVal;
              }
            }

            this.changeDetection.detectChanges();
          }
        } else if (this.type == 1 && model["Id"] > 0 && this.loadedOnModelLoad == false) {
          this.loadedOnModelLoad = true;

          // model data has been loaded 
          // if loadItemsOnModelLoad is true -> load items again
          if (this.loadItemsOnModelLoad != null && typeof this.loadItemsOnModelLoad != "undefined" && this.loadItemsOnModelLoad == true) {
            this.loadItems();
          }
        }


        if (typeof this.autoSelectCondition != "undefined" && this.autoSelectCondition && this.autoSelectCondition.length > 0) {
          try {
            this.conditionValue = eval("function doIt(model){" + this.autoSelectCondition + "} doIt(model);");
            if (this.type == 2) {
              this.loadAutoComplete("");
              this.loadedOnModelLoad = true;
            }
          }
          catch (e) {
            console.log("Error setting default value from autoselect condition", e);
          }

        }

        /*if (this.defaultValue != null && typeof this.defaultValue != "undefined" && this.defaultValue != "" && (this.params["id"] == null || typeof this.params["id"] == "undefined" || this.params["id"] == 0)) {
          this.loadItems(parseInt(this.defaultValue));
        } else {
          this.loadItems();
        }*/

        //this.loadItems();
        if (typeof this.autoSelectCondition != "undefined" && this.autoSelectCondition && this.autoSelectCondition.length > 0) {
          let currentVal = this.dfms.getValue(model, this.bindingPropertyName);
          if (typeof currentVal != "undefined" && currentVal) {
            this.value = currentVal;
            this.id = currentVal["Id"];
            this.changeDetection.detectChanges();
          }
        }
      }
      //This causes problems when large number of dropdowns in present on the form... since we do not have the scenario with initial load needed for autocomplete dropdown, we commented that out
      /*l["Id"] > 0 && this.loadedOnModelLoad == false){
        this.loadedOnModelLoad = true;
        this.loadAutoComplete("");
      }*/

    });

  }

  ngModelChangeEvent(ev) {

  }

  ordinalChange(ev) {

  }

  addSorting(query) {

    if (query != null) {
      var sorting = [];

      var classType = query["ClassType"];      
      if (classType == null || typeof classType == "undefined" || classType == "") {
        classType = query["ClassTypes"][0];
      }

      if(this.sortFields && this.sortFields.length > 0){
        this.sortFields.forEach((sf, index) => {
          sorting.push({
            "FieldName": sf.SortPropertyPath,
            "Direction": sf.SortDirection,
            "RootClassName": classType
          });
        });        
      }else{
        sorting.push({
          "FieldName": "Id",
          "Direction": 0,
          "RootClassName": classType
        });
      }      

      query["SortFields"] = sorting;
    }

    return query;
  }

  loadItems(defaultValueId: number = 0) {

    if (this.predefinedValueEvent != "" && this.predefinedValueEvent != null && typeof this.predefinedValueEvent != "undefined") {
      this.id = parseInt(this.predefinedValueEvent);
    } else {
      this.id = 0;
    }

    if (defaultValueId > 0) {
      this.id = defaultValueId;
    } else {
      this.id = 0;
    }

    if (this.galregistryname.length > 0) {

      this.loadingResults = true;
      let defaultValueTreeQuery = null;

      if (defaultValueId > 0) {
        defaultValueTreeQuery = {
          "Type": "FieldValue",
          "FieldName": "Id",
          "FieldValue": "" + this.defaultValue
        };
      }

      // use custom delimiter ${ }
      _.templateSettings.interpolate = /\${([\s\S]+?)}/g;
      let formModel = {};

      if (this.model != null && typeof this.model != "undefined") {
        formModel = this.model;
      }

      if (Object.keys(formModel).length == 0 || this.useGlobalModel) {
        if (this.dfms.globalModel != null && typeof this.dfms.globalModel != "undefined") {
          formModel = this.dfms.globalModel;
        }
      }

      if (this.searchQueryFilter != null && typeof this.searchQueryFilter != "undefined" && Object.entries(this.searchQueryFilter).length !== 0 && this.searchQueryFilter.constructor !== Object) {

        try {

          let requestModel: RequestModel = new RequestModel();
          requestModel.url = "/api/registry/dropdown";
          requestModel.contentType = "application/json"
          let searchQ = Object.assign({}, this.query);//JSON.parse(this.searchQueryFilter);
          let interpolateError: boolean = false;
          // no need for inerpolate since we have default value tree query
          if (defaultValueTreeQuery == null) {
            try {
              // interpolate
              let compiled = _.template(this.searchQueryFilter);
              let compiledSearchQuery = compiled(formModel);
              if (compiledSearchQuery != null && typeof compiledSearchQuery != "undefined") {
                let interpolateMainSearchQueryObject = JSON.parse(compiledSearchQuery);
                searchQ["TreeQuery"] = interpolateMainSearchQueryObject;
              }
            } catch {
              interpolateError = true;
              //let searchQ = Object.assign({}, this.query);
            }

          } else {
            searchQ["TreeQuery"] = defaultValueTreeQuery;
          }

          if (!interpolateError) {
            searchQ["ClassType"] = this.galregistryname;
            searchQ["Projection"] = this.getProjection();

            // Tree mode (type 4) always loads the full registry - a CustomPageSize from the
            // form settings would truncate the list (entries past the page are unfindable,
            // and children of unloaded parents silently drop out of the hierarchy).
            if (this.type != 4 && this.customPageSize != null && typeof this.customPageSize != "undefined" && this.customPageSize > 0) {
              searchQ["PageSize"] = this.customPageSize;
            }


            searchQ = this.addSorting(searchQ);
            requestModel.data = searchQ;
            this.restProviderService.getDataPOST<any>(requestModel).subscribe(data => {
              this.zone.run(() => {
                let result = data["Models"];

                this.preSelectedEntity = null;

                // clear before setting new list from response
                this.list = [];
                for (var i = 0; i < result.length; i++) {
                  this.list = [...this.list, result[i]["Model"]];

                  if (this.id > 0) {
                    if (result[i]["Model"]["Id"] == this.id) {
                      this.preSelectedEntity = result[i]["Model"];
                    }
                  }
                }

                if (this.titleField == "" || this.titleField == null || typeof this.titleField == "undefined") {
                  this.titleField = "Title";
                  this.changeDetection.detectChanges();
                } else {
                  this.changeDetection.detectChanges();
                }
                this.itemsLoaded = true;

                if (this.type == 4) { this.buildTree(); }

                // also check that we're not on details form (then value is based on entity)
                if (this.autoSelectFirstEntry && (this.clientUIControl || (this.params["id"] == null || typeof this.params["id"] == "undefined"))) {
                  if (this.list != null && typeof this.list != "undefined" && this.list.length > 0) {

                    this.autoselect = true;

                    if (this.autoSelectFirstEntryCondition != null && typeof this.autoSelectFirstEntryCondition != "undefined") {
                      // autoSelectFirstEntryCondition should set value of this.autoselect to true/false
                      let preResult = function (str) {
                        return eval(str);
                      }.call(this, this.autoSelectFirstEntryCondition);
                    }

                    if (this.autoselect === true) {
                      var value = this.list[0];
                      value["ObjectType"] = this.galregistryname;
                      this.value = value;
                    }

                  }
                }

                if (this.preSelectedEntity) {
                  this.value = this.preSelectedEntity;
                }

                if (this.value && this.type == 3) {
                  for (var i = 0; i < this.list.length; i++) {
                    if (this.list[i]["Id"] == this.value["Id"]) {
                      this.list[i] = this.value;
                    }
                  }
                }

                if (this.conditionValue != null) {
                  this.conditionApplied = true;
                  this.defaultValue = this.conditionValue;
                  //this.value = this.list[this.conditionValue];
                  this.value = this.list.filter(x => x.Id == this.conditionValue)[0];
                  this.changeDetection.detectChanges();
                }
                this.loadingResults = false;
              });
            },
              error => {
                //console.log("Error", error);
                this.loadingResults = false;
              }
            );
          } else {
            this.loadingResults = false;
          }
        } catch (e) {
          this.loadingResults = false;
        }
      } else {

        let requestModel: RequestModel = new RequestModel();
        requestModel.contentType = "application/json"

        let useCustomApi = true;
        if (this.useCustomApiCondition != null && typeof this.useCustomApiCondition != "undefined" && this.useCustomApiCondition.length > 0) {
          useCustomApi = eval(this.useCustomApiCondition);
        }

        if (useCustomApi === true && this.customDataApi != null && typeof this.customDataApi != "undefined" && this.customDataApi.length > 0) {
          requestModel.url = this.customDataApi;

          if (this.customDataApiInputParameters != null && typeof this.customDataApiInputParameters != "undefined" && Object.keys(this.customDataApiInputParameters).length > 0) {
            try {
              // interpolate
              let compiled = _.template(this.customDataApiInputParameters);
              let compiledInputParams = compiled(formModel);
              if (compiledInputParams != null && typeof compiledInputParams != "undefined") {
                let compiledInputParamsObject = JSON.parse(compiledInputParams);
                requestModel.data = { "InputParameters": compiledInputParamsObject };
              }
            } catch {
            }
          }

        } else {
          requestModel.url = "/api/registry/dropdown";
          let searchQ = Object.assign({}, this.query);//JSON.parse(this.searchQueryFilter);
          searchQ["ClassType"] = this.galregistryname;

          searchQ["Projection"] = this.getProjection();

          // Tree mode (type 4) always loads the full registry - see comment in the branch above.
          if (this.type != 4 && this.customPageSize != null && typeof this.customPageSize != "undefined" && this.customPageSize > 0) {
            searchQ["PageSize"] = this.customPageSize;
          }


          if (defaultValueTreeQuery != null) {
            searchQ["TreeQuery"] = defaultValueTreeQuery;
          }

          searchQ = this.addSorting(searchQ);
          requestModel.data = searchQ;
        }

        if(requestModel.data == "undefined" || requestModel.data == null){
          requestModel.data = {}; //request needs to have content even if it's empty object cause we set the content type...
        }

        this.restProviderService.getDataPOST<any>(requestModel).subscribe(data => {
          this.zone.run(() => {
            let result = data.Models;
            this.preSelectedEntity = null;
            // clear before setting new list from response
            this.list = [];
            for (var i = 0; i < result.length; i++) {
              this.list = [...this.list, result[i]["Model"]];

              if (this.id > 0) {
                if (result[i]["Model"]["Id"] == this.id) {
                  this.preSelectedEntity = result[i]["Model"];
                }
              }
            }

            if (this.titleField == "" || this.titleField == null || typeof this.titleField == "undefined") {
              this.titleField = "Title";
              this.changeDetection.detectChanges();
            } else {
              this.changeDetection.detectChanges();
            }
            this.itemsLoaded = true;

            if (this.type == 4) { this.buildTree(); }

            // also check that we're not on details form (then value is based on entity)
            if (this.autoSelectFirstEntry && (this.clientUIControl || (this.params["id"] == null || typeof this.params["id"] == "undefined"))) {
              if (this.list != null && typeof this.list != "undefined" && this.list.length > 0) {


                this.autoselect = true;

                if (this.autoSelectFirstEntryCondition != null && typeof this.autoSelectFirstEntryCondition != "undefined") {
                  // autoSelectFirstEntryCondition should set value of this.autoselect to true/false
                  let preResult = function (str) {
                    return eval(str);
                  }.call(this, this.autoSelectFirstEntryCondition);
                }

                if (this.autoselect === true) {
                  var value = this.list[0];
                  value["ObjectType"] = this.galregistryname;
                  this.value = value;
                }


              }
            }

            if (this.preSelectedEntity) {
              this.value = this.preSelectedEntity;
            }

            if (this.value && this.type == 3) {
              for (var i = 0; i < this.list.length; i++) {
                if (this.list[i]["Id"] == this.value["Id"]) {
                  this.list[i] = this.value;
                }
              }
            }


            if (this.conditionValue != null) {
              this.conditionApplied = true;
              this.defaultValue = this.conditionValue;
              this.value = this.list.filter(x => x.Id == this.conditionValue)[0];
              this.changeDetection.detectChanges();
            }

            this.loadingResults = false;
            this.changeDetection.detectChanges();

          });
        }, error => {
          this.list.push("Error retrieving data for dropdown");
          this.loadingResults = false;
        });
      }
    }
  }

  getProjection() {
    let projections = [];
    if (typeof this.filterField != undefined && this.filterField != null && this.filterField != "") {
      projections.push(this.filterField);
    }
    if (this.additionalProjectionOriginal != null && typeof this.additionalProjectionOriginal != "undefined" && this.additionalProjectionOriginal.length > 0) {
      var array = Object.assign([], this.additionalProjectionOriginal);
      for (var i = 0; i < array.length; i++) {
        if (typeof array[i] === 'string' || array[i] instanceof String) {
          projections.push(array[i]);
        }
      }
    }

    // Tree mode needs the parent link to rebuild the hierarchy, plus the configured display
    // field (TitleField) for the collapsed value. No module-specific fields here - if a module
    // wants a calculated path (e.g. a hierarchical full name), it sets it as TitleField.
    if (this.type == 4) {
      const treeProjections = ["Parent.Id", "Title"];

      if (this.titleField && this.titleField.length > 0) {
        treeProjections.push(this.titleField);
      }

      treeProjections.forEach(p => {
        if (projections.indexOf(p) === -1) {
          projections.push(p);
        }
      });
    }

    return projections;
  }

  clearValue(event) {

    let attName = this.getAttribute("name");

    let control = this.dfms.globalForm.controls[attName];

    if (control !== null && typeof control !== "undefined") {
      this.dfms.globalForm.controls[attName].setValue(null);
      this.dfms.globalForm.controls[attName].updateValueAndValidity();
    }

    this.dfms.updateControlsValidationArray(attName, null);

    event.stopPropagation();
    this.valueRemoved = true;
    this.value = null;
    this.typedInputLeft = false;
    if (this.type == 2 && typeof this.myControl.value === 'string') {
      this.myControl.setValue('', { emitEvent: false });
    }

    // execute code after dropdown value is cleared (value is null here)
    if (this.onClearPostJS != null && typeof this.onClearPostJS != "undefined" && this.onClearPostJS.length > 0) {
      let value = null;
      try {
        let preResult = function (str) {
          return eval(str);
        }.call(this, this.onClearPostJS);
      } catch (e) { console.warn('[SemSelect] onClearPostJS error', e); }
    }
  }

  loadAutoComplete(searchTerm) {

    if (searchTerm.length == 0) {
      searchTerm = "*";
    }
    else {
      searchTerm = searchTerm + "*";
    }

    // use custom delimiter ${ }
    _.templateSettings.interpolate = /\${([\s\S]+?)}/g;

    let formModel = {};

    if (this.model != null && typeof this.model != "undefined") {
      formModel = this.model;
    }

    if (Object.keys(formModel).length == 0 || this.useGlobalModel) {
      if (this.dfms.globalModel != null && typeof this.dfms.globalModel != "undefined") {
        formModel = this.dfms.globalModel;
      }
    }

    let autocompleteTreeQuery = { Type: "FieldValue", FieldName: this.filterField, FieldValue: searchTerm }

    let requestModel: RequestModel = new RequestModel();
    requestModel.contentType = "application/json"
    let interpolateError: boolean = false;
    requestModel.url = "/api/registry/dropdown";
    let searchQ = Object.assign({}, this.query);
    searchQ["ClassType"] = this.galregistryname;
    searchQ["ClassTypes"] = [this.galregistryname];
    searchQ["Projection"] = this.getProjection();

    if (this.searchQueryFilter != null && typeof this.searchQueryFilter != "undefined" && Object.entries(this.searchQueryFilter).length !== 0 && this.searchQueryFilter.constructor !== Object) {
      try {
        // interpolate
        let compiled = _.template(this.searchQueryFilter);
        let compiledSearchQuery = compiled(formModel);

        if (compiledSearchQuery != null && typeof compiledSearchQuery != "undefined") {
          let interpolateMainSearchQueryObject = JSON.parse(compiledSearchQuery);

          var andQuery = {
            "Type": "AND",
            "SubQueries": []
          };

          andQuery["SubQueries"].push(interpolateMainSearchQueryObject);
          andQuery["SubQueries"].push(autocompleteTreeQuery);

          searchQ["TreeQuery"] = andQuery;
        }
      } catch {
        interpolateError = true;
        //searchQ["TreeQuery"] = autocompleteTreeQuery;
      }
    } else {
      searchQ["TreeQuery"] = autocompleteTreeQuery;
    }

    if (!interpolateError) {
      if (this.customPageSize != null && typeof this.customPageSize != "undefined" && this.customPageSize > 0) {
        searchQ["PageSize"] = this.customPageSize;
      }

      let useCustomApi = true;
      if (this.useCustomApiCondition != null && typeof this.useCustomApiCondition != "undefined" && this.useCustomApiCondition.length > 0) {
        useCustomApi = eval(this.useCustomApiCondition);
      }

      if (useCustomApi === true && this.customDataApi != null && typeof this.customDataApi != "undefined" && this.customDataApi.length > 0) {
        requestModel.url = this.customDataApi;
        let inputParams = null;
        if (this.customDataApiInputParameters != null && typeof this.customDataApiInputParameters != "undefined" && Object.keys(this.customDataApiInputParameters).length > 0) {
          try {
            // interpolate
            let compiled = _.template(this.customDataApiInputParameters);
            let compiledInputParams = compiled(formModel);
            if (compiledInputParams != null && typeof compiledInputParams != "undefined") {
              let compiledInputParamsObject = JSON.parse(compiledInputParams);
              inputParams = compiledInputParamsObject;
            }
          } catch {
          }
        }

        requestModel.data = { "Envelope": { "SearchTerm": searchTerm, "Projection": this.getProjection(), "PageSize": this.customPageSize }, "InputParameters": inputParams };
      } else {
        searchQ = this.addSorting(searchQ);
        requestModel.data = searchQ;
      }

      // Skip only a truly identical repeat call - same endpoint AND same interpolated payload.
      // The key is reset when the panel closes, so every fresh open reloads the options.
      let requestKey = this.buildAutoCompleteRequestKey(requestModel);

      if (this.previousRequestKey != null && this.previousRequestKey == requestKey) {
        this.loadingResults = false;
        return;
      }

      this.restProviderService.getDataPOST<any>(requestModel).pipe(takeUntil(this.req)).subscribe(data => {
        this.zone.run(() => {
          let result = data["Models"];

          // only remember the request once it actually returned - a cancelled call must not
          // block the next identical one
          this.previousRequestKey = requestKey;

          this.list = [];
          for (var i = 0; i < result.length; i++) {
            this.list = [...this.list, result[i]["Model"]];
          }

          //this.filteredOptions = of(this.list.map(value => this._filter(value)));

          if (this.titleField == "" || this.titleField == null || typeof this.titleField == "undefined") {
            this.titleField = "Title";
            this.changeDetection.detectChanges();
          } else {
            this.changeDetection.detectChanges();
          }

          /*if (searchTerm == "*") {
            this.filteredOptions = of(this.list);
          }*/
          this.filteredOptions = of(this.list);
          this.loadingResults = false;

          if (this.conditionValue != null && (typeof this.value == "undefined" || !this.value)) {
            this.conditionApplied = true;
            this.defaultValue = this.conditionValue;
            //this.value = this.list[this.conditionValue];
            this.value = this.list.filter(x => x.Id == this.conditionValue)[0];
            this.changeDetection.detectChanges();
          }

        });
      },
        error => {
          //console.log("Error", error);
          this.loadingResults = false;
        }
      );
    } else {
      this.loadingResults = false;
    }
  }

  /**
   * Identity of an autocomplete request: endpoint + fully interpolated payload.
   * Search term alone would be misleading - with a custom API the payload also carries
   * InputParameters/TreeQuery built from the current form model, so the same term can mean
   * a different request after the user edits other fields.
   */
  private buildAutoCompleteRequestKey(requestModel: RequestModel): string {
    let payload = "";

    try {
      payload = JSON.stringify(requestModel.data);
    } catch {
      // non-serializable payload - treat as always changed
      return null;
    }

    return requestModel.url + "|" + payload;
  }

  compareFn(c1: any, c2: any): boolean {
    var res = c1 && c2 ? c1.Id == c2.Id : c1 === c2;

    return res;
  }

  compareFnR(c1: any, c2: any): boolean {
    var res = c1 && c2 ? c1.Id == c2.Id : c1 === c2;
    return res;
  }

  radioButtonChange(event) {
    let attName = this.getAttribute("name");

    let control = this.dfms.globalForm.controls[attName];

    if (control !== null && typeof control !== "undefined") {
      this.dfms.globalForm.controls[attName].setValue(event.source.value);
      this.dfms.globalForm.controls[attName].updateValueAndValidity();
    }

    this.dfms.updateControlsValidationArray(attName, event.source.value);

    if (typeof this.onValueChangeEval != "undefined" && this.onValueChangeEval) {
      eval(this.onValueChangeEval);
    }
  }

  radioChange(event) {

  }

  valueChanged() {
  }

  valueModified() {
    //console.log("Value modified: ", this.value);
  }

  // Quick-create helpers — opens the bottom drawer with the registry's create form
  // and selects the new entry on save.
  get quickCreateAvailable(): boolean {
    if (!this.enableQuickCreate) return false;
    if (this.isReadOnly === true || this.isReadOnly === 'true') return false;
    if (this.dfms?.isFormReadOnly) return false;
    return true;
  }

  openQuickCreatePanel(event?: Event) {
    if (event) { event.stopPropagation(); event.preventDefault(); }
    if (!this.quickCreateAvailable) return;
    const registryName = (this.quickCreateRegistry && this.quickCreateRegistry.length > 0)
      ? this.quickCreateRegistry
      : this.galregistryname;
    if (!registryName) return;

    const route = this.searchService.resolveQuickCreateRoute(registryName);
    if (!route) {
      console.warn('[SemSelect] quick-create: could not resolve route for registry', registryName);
      return;
    }

    if (this.matSelect) this.matSelect.close();

    this.searchService.openQuickCreate({
      registryName,
      formLink: route.formLink,
      routePath: route.routePath,
      title: route.title,
      onSaved: (entry) => this.appendAndSelectEntry(entry)
    });
  }

  // inline and full-form both render their affordance as the last row of the dropdown panel.
  get quickCreateUsesFooter(): boolean {
    return this.quickCreateMode === 'inline' || this.quickCreateMode === 'full-form';
  }

  // translate(key) returns the key itself when the dictionary has no entry
  // (translations-provider.service.ts); fall back to the Slovenian default in that case.
  tr(key: string, fallback: string): string {
    const v = this.translationsService.translate(key);
    return v === key ? fallback : v;
  }

  // mat-select / mat-autocomplete panel open/close — in inline / full-form mode, mount the
  // ng-template footer into the CDK overlay panel so it lives inside the dropdown.
  onPanelOpenedChange(opened: boolean) {
    this.autocompletePanelOpen = opened;
    if (!opened) {
      // forget the last autocomplete request so the next open reloads the options
      // (form data may have changed in the meantime, which changes the custom API payload)
      this.previousRequestKey = null;
    }

    if (!this.quickCreateAvailable || !this.quickCreateUsesFooter) return;
    if (opened) {
      // Wait one tick for Material to render the panel into the CDK overlay container.
      setTimeout(() => this.attachInlineFooter(), 0);
    } else {
      this.detachInlineFooter();
    }
  }

  private attachInlineFooter() {
    const tpl = this.quickCreateMode === 'full-form' ? this.fullFormFooterTpl : this.inlineCreateFooterTpl;
    if (this.inlineFooterRef || !tpl) return;
    const panel = document.querySelector(
      '.mat-mdc-select-panel.wg-inline-create-panel, .mat-mdc-autocomplete-panel.wg-inline-create-panel'
    ) as HTMLElement | null;
    if (!panel) return;
    this.inlineFooterRef = this.inlineFooterVcr.createEmbeddedView(tpl);
    this.inlineFooterRef.detectChanges();
    this.inlineFooterRef.rootNodes.forEach((n: HTMLElement) => panel.appendChild(n));
  }

  private detachInlineFooter() {
    if (this.inlineFooterRef) {
      this.inlineFooterRef.destroy();
      this.inlineFooterRef = null;
    }
  }

  // Full-form quick-create — opens the backend form (QuickCreateFormId, or the registry's own
  // form) in SemQuickCreateFormDialogComponent and selects the saved entry on close.
  openQuickCreateFullForm(event?: Event) {
    if (event) { event.stopPropagation(); event.preventDefault(); }
    if (!this.quickCreateAvailable || this.quickCreateMode !== 'full-form') return;

    const formId = Number(this.quickCreateFormId) || 0;
    const registryName = (this.quickCreateRegistry && this.quickCreateRegistry.length > 0)
      ? this.quickCreateRegistry
      : this.galregistryname;
    const route = formId > 0
      ? this.searchService.resolveQuickCreateRouteByFormId(formId)
      : this.searchService.resolveQuickCreateRoute(registryName);
    if (!route) {
      console.warn('[SemSelect] quick-create: could not resolve route for', formId > 0 ? 'form id ' + formId : registryName);
      return;
    }

    // Autocomplete: carry the typed search text over as the new entry's title.
    const typed = this.type == 2 && typeof this.myControl.value === 'string' ? this.myControl.value.trim() : '';
    const initialModel: any = {};
    if (typed) {
      initialModel.Title = typed;
      if (this.titleField && this.titleField !== 'Title') initialModel[this.titleField] = typed;
    }

    if (this.matSelect) this.matSelect.close();
    this.detachInlineFooter();

    const ref = this.dialog.open(SemQuickCreateFormDialogComponent, {
      width: '720px',
      maxHeight: '90vh',
      disableClose: true,
      autoFocus: 'first-tabbable',
      data: { formLink: route.formLink, formUrl: route.url, title: route.title, initialModel }
    });
    ref.afterClosed().subscribe((res: QuickCreateFormDialogResult | undefined) => {
      if (res && res.saved && res.model && res.model.Id) {
        this.appendAndSelectEntry(res.model);
      }
    });
  }

  // Inline create — single-field POST to /api/data with ApplicationModelFullName.
  // Same endpoint the regular form save uses, so we get full validation, Lucene re-index,
  // audit and workflow handling. If the registry has more than one required field, the
  // server will reject and the registry owner should switch to panel mode.
  createInline() {
    if (!this.quickCreateAvailable || this.quickCreateMode !== 'inline') return;
    const text = (this.inlineCreateText || '').trim();
    if (!text || this.inlineCreating) return;

    const fullName = (this.quickCreateRegistry && this.quickCreateRegistry.length > 0)
      ? this.quickCreateRegistry
      : this.galregistryname;
    if (!fullName) return;

    // Set Title and the configured title field (often Name) for compatibility across registries.
    const envelope: any = { Title: text, Name: text };
    if (this.titleField && this.titleField !== 'Title' && this.titleField !== 'Name') {
      envelope[this.titleField] = text;
    }

    // Projection is required by the BE save pipeline. We ask for the fields needed to render
    // the new entry as the dropdown's selected value.
    const projection = ['Id', 'Title', 'Name'];
    if (this.titleField && !projection.includes(this.titleField)) projection.push(this.titleField);

    const reqModel = new RequestModel();
    reqModel.url = 'api/data';
    reqModel.data = {
      Envelope: envelope,
      Projection: projection,
      ApplicationModelFullName: fullName
    };

    this.inlineCreating = true;
    this.changeDetection.detectChanges();

    this.restProviderService.getDataPOST<any>(reqModel).subscribe({
      next: (res: any) => {
        this.inlineCreating = false;
        const created = (res && (res.Model || res)) || null;
        if (created && created.Id) {
          this.inlineCreateText = '';
          // Close the dropdown panel and select the new entry.
          if (this.matSelect) this.matSelect.close();
          this.detachInlineFooter();
          this.appendAndSelectEntry(created);
        } else {
          console.warn('[SemSelect] inline-create: unexpected response shape', res);
        }
        this.changeDetection.detectChanges();
      },
      error: (err: any) => {
        this.inlineCreating = false;
        console.error('[SemSelect] inline-create failed', err);
        this.changeDetection.detectChanges();
      }
    });
  }

  private appendAndSelectEntry(entry: any) {
    if (!entry || !entry.Id) return;
    if (!this.list) this.list = [];
    const exists = this.list.find(i => i && i.Id === entry.Id);
    if (!exists) {
      // newest first: the entry the user just created should be the first option
      this.list = [entry, ...this.list];
    }
    const selected = exists || entry;

    const attName = this.getAttribute('name');
    const control = this.dfms?.globalForm?.controls?.[attName];
    if (control) {
      control.setValue(selected);
      control.updateValueAndValidity();
    }
    this.value = selected;
    this.dfms.updateControlsValidationArray(attName, selected);

    if (typeof selected !== 'number' && typeof selected !== 'string') {
      selected['ObjectType'] = this.galregistryname;
    }
    this.itemSelected.emit(selected);
    this.utility.newDropdownValueSelected(selected, this.bindingPropertyName);

    if (this.onSelectPostJS && this.onSelectPostJS.length > 0) {
      try {
        (function (str) { return eval(str); }).call(this, this.onSelectPostJS);
      } catch (e) { console.warn('[SemSelect] onSelectPostJS error', e); }
    }

    this.changeDetection.detectChanges();
  }

  //TODO: Leave this commented out, need to check if it is required for hiding of controls, or for seting them as readonly
  selectionChange(event: MatOptionSelectionChange) {

    /*this.autoSelectCondition = null;
    this.conditionValue = null;
    this.defaultValue = null;
    this.conditionApplied = false;*/

    let value = event.source.value;
    // set value to model
    //this.dfms.assign(this.model, this.bindingPropertyName, value, true);  
    let attName = this.getAttribute("name");

    let control = this.dfms.globalForm.controls[attName];

    if (control !== null && typeof control !== "undefined") {
      this.dfms.globalForm.controls[attName].setValue(event.source.value);
      this.dfms.globalForm.controls[attName].updateValueAndValidity();
    }

    this.dfms.updateControlsValidationArray(attName, event.source.value);

    this.changeDetection.detectChanges();

    if (typeof value != "number" && typeof value != "string") {
      value["ObjectType"] = this.galregistryname;
    }

    this.itemSelected.emit(value);

    if (this.useAsMultiField) {
      this.processMultiField(value);
    }

    this.utility.newDropdownValueSelected(value, this.bindingPropertyName);

    // execute code after dropdown option is selected 
    if (this.onSelectPostJS != null && typeof this.onSelectPostJS != "undefined" && this.onSelectPostJS.length > 0) {
      let preResult = function (str) {
        return eval(str);
      }.call(this, this.onSelectPostJS);
    }

    setTimeout(() => {
      if (this.galregistryname.includes("PenaltyType")) {

        var result = document.getElementsByClassName("mat-tab-label");

        for (var i = 0; i <= result.length; i++) {
          // continue from selected on (ignore previous tabs)
          // check if not disabled      
          if (result[i]["innerText"].includes("-")) {
            result[i]["style"]["display"] = "none";
          };
        }
      }
    }, 50);
  }

  processMultiField(value) {
    // get fields based on selected item
    // send them to another control via event

    let requestModel: RequestModel = new RequestModel();
    requestModel.url = "/api/dynamicforms/multifields/definition";
    requestModel.contentType = "application/json"
    let reqDataModel = {
      "Id": value["Id"],
      "FullName": this.galregistryname,
      "MultiFieldPropertyName": this.multiFieldPropertyName
    };
    requestModel.data = reqDataModel;

    this.restProviderService.getDataPOST<any>(requestModel).subscribe(data => {
      this.zone.run(() => {
        if (data != null && typeof data != "undefined" && data.length > 0) {
          this.multiFields = data;
        }
      });
    },
      error => {
        //console.log("Error", error);
      }
    );
  }

  dropdownSelectClick() {
    // if defaultValue is specified then all items for dropdown are not loaded onInit (only default value)
    // here we load all dropdown options (only once)

    if (this.defaultValue !== null && typeof this.defaultValue !== "undefined" && this.defaultValue !== "" && this.dropdownOptionsLoaded == false) {
      this.dropdownOptionsLoaded = true;
      this.loadItems();
    }
  }

  ddInitialSet(event: MatOptionSelectionChange) {

    if (!this.initialSet) {
      this.initialSet = true;
      if (event.source != null && typeof event.source != "undefined" && event.source.value != null && typeof event.source.value != "undefined" && this.useAsMultiField) {
        this.processMultiField(event.source.value);
      }
      //this.selectionChange(event);
    }

    for (var i = 0; i < this.dfms.metaModel.length; i++) {
      if (this.dfms.metaModel[i].W == 0 && "model." + this.dfms.metaModel[i].Path == this.getAttribute("name")) {
        if (this.matSelect) {
          this.matSelect.disabled = true;
        }
        break;
      }
    }

    if (this.preSelectedEntity) {
      this.value = this.preSelectedEntity;
    }



  }

  private _filter(value) {

    let filterValue = "";

    if (typeof value === 'object') {
      let val = this.resolvePropertyBinding(value, this.titleField);
      filterValue = val.toLowerCase();
    } else {
      filterValue = value.toLowerCase();
    }


    //if (!this.loadingResults) {
    this.loadingResults = true;
    this.req.next();
    this.loadAutoComplete(filterValue);
    //}

    return this.list.filter(option => this.resolvePropertyBinding(option, this.titleField).toLowerCase().includes(filterValue));

  }

  focusDropdown() {
    if (this.searchQueryFilter != null && typeof this.searchQueryFilter != "undefined" && Object.keys(this.searchQueryFilter).length > 2 && this.type == 1 && this.clientUIControl == false) {
      this.loadItems();
    }
  }

  displayFn(value) {
    // now you have access to 'this' 
    return value ? this.resolvePropertyBinding(value, this.titleField) : undefined;
  }

  getValue() {
    if (typeof (this.value) != "undefined" && this.value != null) {
      return this.resolvePropertyBinding(this.value, this.titleField)
    }
    return "";
  }

  optionSelected(option) {
    this.value = option;
    this.typedInputLeft = false;

    let attName = this.getAttribute("name");

    if (attName !== null && attName !== undefined) {
      let control = this.dfms.globalForm.controls[attName];

      if (control !== null && typeof control !== "undefined") {
        this.dfms.globalForm.controls[attName].setValue(option);
        this.dfms.globalForm.controls[attName].updateValueAndValidity();
      }

      this.dfms.updateControlsValidationArray(attName, option);
    }

    if (this.type == 2) {
      if (this.useAsMultiField) {
        this.processMultiField(option);
      }
      this.utility.newDropdownValueSelected(option, this.bindingPropertyName);
    }

    // execute code after autocomplete dropdown option is selected    
    if (this.onSelectPostJS != null && typeof this.onSelectPostJS != "undefined" && this.onSelectPostJS.length > 0) {
      let preResult = function (str) {
        return eval(str);
      }.call(this, this.onSelectPostJS);
    }

    this.itemSelected.emit(option);
  }

  onAutocompleteBlur() {
    this.typedInputLeft = true;
  }

  /**
   * Autocomplete (type 2): text typed in the input that was never picked from the options.
   * Such text is not bound to the model, so the save would carry nothing (or the previous
   * selection). Shown as invalid once the user leaves the field with the panel closed.
   */
  get typedValueNotInList(): boolean {
    if (this.type != 2 || !this.typedInputLeft || this.autocompletePanelOpen) return false;
    const typed = this.myControl.value;
    if (typeof typed !== 'string' || typed.trim().length === 0) return false;
    return typed.trim() !== String(this.getValue() ?? '').trim();
  }

  onFocus() {
    this.typedInputLeft = false;
    if (!this.valueRemoved) {
      // opening the dropdown always reloads - the options can depend on form data
      // that changed since the last time it was opened
      this.previousRequestKey = null;
      this.req.next();
      this.loadingResults = true;
      this.loadAutoComplete("");
    }
    this.valueRemoved = false;
    /*if (this.type == "2") {
      this.loadingResults = true;
      this.req.next();

      let value = "";

      if (typeof (this.myControl.value) != "undefined" && this.myControl.value != null) {
        value = this.myControl.value;
      }

      this.loadAutoComplete(value);
    } else {
      if (!this.preLoad) {
        this.loadItems();
      }
    }*/
  }

  onSearchChange(searchValue: string) {
    //if (!this.loadingResults) {
    this.req.next();
    this.loadingResults = true;
    this.loadAutoComplete(searchValue);
    //}
  }

  resolvePropertyBinding(object, propertyPath) {

    if (typeof propertyPath != "undefined" && propertyPath != null) {

      if (typeof object == "number"
        || typeof object == "string") {
        return object;
      }

      let split = propertyPath.split(".");
      let obj = object;

      for (let i = 0; i < split.length; i++) {
        if (obj != null && typeof obj != "undefined") {
          obj = obj[split[i]];
        }
      }

      if (obj != null && typeof obj != "undefined") {
        return obj;
      }
    }

    return "";
  }


  // ===== Tree mode helpers (type == 4) =====

  treeHasChild = (_: number, node: any) => !!node.children && node.children.length > 0;

  /**
   * Builds the hierarchical tree from the flat `list` (each item carries Parent.Id).
   * Nodes whose parent is not part of the loaded set are treated as roots so nothing is hidden.
   */
  buildTree() {
    const source = this.list || [];

    const nodes = source.map(entity => ({
      entity: entity,
      id: entity ? entity["Id"] : null,
      parentId: (entity && entity["Parent"] && entity["Parent"]["Id"]) ? entity["Parent"]["Id"] : null,
      name: this.resolvePropertyBinding(entity, "Title") || this.resolvePropertyBinding(entity, this.titleField) || "",
      children: []
    }));

    const byId = {};
    nodes.forEach(n => { if (n.id != null) { byId[n.id] = n; } });

    nodes.forEach(n => {
      n.children = nodes.filter(c => c.parentId != null && c.parentId == n.id);
    });

    const roots = nodes.filter(n => n.parentId == null || typeof byId[n.parentId] == "undefined");
    roots.sort((a, b) => (a.name || "").localeCompare(b.name || ""));

    this.treeFlatNodes = nodes;
    this.treeDataSource.data = roots;
    this.treeControl.dataNodes = nodes;
    this.changeDetection.detectChanges();
  }

  toggleTreePanel() {
    if (this.checkForDisabled(this.getAttribute('name')) || this.dfms?.isFormReadOnly == true) {
      return;
    }
    this.treePanelOpen = !this.treePanelOpen;
    if (this.treePanelOpen && (!this.list || this.list.length == 0)) {
      this.loadItems();
    }
  }

  closeTreePanel() {
    this.treePanelOpen = false;
  }

  selectTreeNode(node: any) {
    if (!node) { return; }

    // Tree rows come from the dropdown projection, so they are PARTIAL objects (e.g. Parent is
    // only { Id }). Posting such a partial Document graph makes the save pipeline flush the
    // missing values as NULLs onto the real rows ("UPDATE location SET name = NULL ...").
    // SemManyToOneControl never had this problem because it always fetched the COMPLETE entity
    // through api/data/relatedentity before putting it on the model - so we do exactly the same.
    const formLink = this.model ? this.model["SerializationObjectFormLink"] : null;

    if (formLink && this.bindingPropertyName && this.galregistryname && node.id > 0) {
      this.loadingResults = true;

      const url = "api/data/relatedentity/" + formLink + "/" + this.bindingPropertyName + "/" + this.galregistryname + "/" + node.id;

      this.restProviderService.getDataGET(url).subscribe((data: any) => {
        this.loadingResults = false;

        let fullEntity = null;
        try {
          const parsed = JSON.parse(data);
          fullEntity = parsed ? parsed["Model"] : null;
        } catch (e) { }

        if (fullEntity && fullEntity["Id"] > 0) {
          // Keep the configured display field from the tree row if the related-entity
          // projection didn't include it (e.g. a calculated property).
          if (node.entity && this.titleField && this.titleField.indexOf(".") === -1
            && node.entity[this.titleField] && !fullEntity[this.titleField]) {
            fullEntity[this.titleField] = node.entity[this.titleField];
          }
          this.applyTreeSelection(fullEntity);
        } else {
          this.applyTreeSelection(node.entity);
        }
      }, error => {
        // Endpoint not applicable (e.g. plain registries) - fall back to the tree row.
        this.loadingResults = false;
        this.applyTreeSelection(node.entity);
      });
    } else {
      this.applyTreeSelection(node.entity);
    }
  }

  private applyTreeSelection(entity: any) {
    this.optionSelected(entity);
    this.treePanelOpen = false;
    this.changeDetection.detectChanges();
  }

  /**
   * Filters the tree by node label. Matching nodes and all their ancestors stay visible; matches are auto-expanded.
   */
  applyTreeFilter() {
    const term = (this.treeFilter || "").trim().toLowerCase();

    if (term.length == 0) {
      this.buildTree();
      this.treeControl.collapseAll();
      return;
    }

    const nodes = this.treeFlatNodes || [];
    const keep = new Set<any>();

    nodes.forEach(n => {
      if ((n.name || "").toLowerCase().indexOf(term) > -1) {
        keep.add(n.id);
        let parentId = n.parentId;
        let guard = 0;
        while (parentId != null && guard < 100) {
          keep.add(parentId);
          const parent = nodes.find(p => p.id == parentId);
          parentId = parent ? parent.parentId : null;
          guard++;
        }
      }
    });

    const filtered = nodes
      .filter(n => keep.has(n.id))
      .map(n => ({ entity: n.entity, id: n.id, parentId: n.parentId, name: n.name, children: [] as any[] }));

    const byId = {};
    filtered.forEach(n => { byId[n.id] = n; });
    filtered.forEach(n => {
      n.children = filtered.filter(c => c.parentId != null && c.parentId == n.id);
    });

    const roots = filtered.filter(n => n.parentId == null || typeof byId[n.parentId] == "undefined");

    this.treeDataSource.data = roots;
    this.treeControl.dataNodes = filtered;
    this.treeControl.expandAll();
    this.changeDetection.detectChanges();
  }

}
